import { render, staticRenderFns } from "./VisionDiagnosisSummary.vue?vue&type=template&id=0b5b2ff4&scoped=true&"
import script from "./VisionDiagnosisSummary.vue?vue&type=script&lang=js&"
export * from "./VisionDiagnosisSummary.vue?vue&type=script&lang=js&"
import style0 from "./VisionDiagnosisSummary.vue?vue&type=style&index=0&id=0b5b2ff4&prod&lang=css&"
import style1 from "./VisionDiagnosisSummary.vue?vue&type=style&index=1&id=0b5b2ff4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5b2ff4",
  null
  
)

export default component.exports